//cn文件
module.exports = {
  index1: "注册",
  index2: "登录",
  index3: "更多信息",
  index3_1: "节点加速",
  ssl: '获取SSL节点',
  ssl_copy: '获取成功，请粘贴至应用程序使用',
  index4: "首页",
  index5: "关于我们",
  index6: "关注我们",
  index7: "语言",
  index8: "选择您的加密资产",
  index9: "是最值得信赖的加密货币交易所，以安全性而闻名。",
  index10: "会员已经加入。",
  index11: "立即开设您的免费帐户",
  index12: "现在注册!",
  index13: "交易市场",
  index14: "一次革命都需要一个领导者。",
  index15: "首屈一指的交易平台专为那些掌握区块链承诺的力量并希望成为运动一部分的人而设计。凭借闪电般的交易速度、可靠的数字钱包和行业领先的安全性，我们创建了一个交易所来引领这项革命性的技术。",
  index16: "我们的优势",
  index17: "安全第一",
  index18: "选择交易所时，信任很重要。这就是为什么安全一直并将永远是我们的首要考虑因素。我们的平台从头开始构建，具有多层保护，部署最有效和可靠的技术以确保资金和交易安全。",
  index19: "超越简单交易的转型",
  index20: "我们相信区块链有潜力提供跨行业和超越加密的突破性解决方案。我们正在与世界各地的团队合作，推进新的、创造性的代币，这些代币可以改变各地商品、服务和运营的管理方式。",
  index21: "快速、强大的技术",
  index22: "我们的交易引擎是为规模和速度而定制的，以促进在大量需求下的实时订单执行。我们通过广泛的 API 支持第三方交易平台和算法交易。",
  index23: "顶级数字货币市场",
  index24: "通过我们广泛的市场列表，把握趋势并充满信心地进行交易。",
  index25: "智能手机",
  index26: "下载数字资产交易应用程序！",
  index27: "直接在您的智能手机上获得一流的加密货币交易所。下载本应用程序进行交易更容易、更快、更安全。",
  index28: "苹果应用商店",
  index29: "谷歌应用商店",
  index30: "用户感言",
  index31: "我们是什么？",
  index32: "我们是一个在线数字资产交易平台。您可以在平台购买各种加密资产，如BTC、LTC、ETH、BCH、GDOGE、XRP、TRX、BNB、和其他加密资产。",
  index33: "比特币是什么?",
  index34: "简单来说，比特币是一种数字资产, 这类资产交易可以在不需要信用卡或央行的去中心化情况下进行. 它的设计是为了让用户能够以非常简单、高效的方式进行网络汇款。比特币由中本聪在2009年开发，这种资产就像黄金, 但只在数字世界中存在. 这个概念听起来可能像数字黄金,尽管它实际上有很大的不同。",
  index35: "如何存款到您账户?",
  index36: '点击 "資產-充值" , 选择 "您要使用的付款方式".例如: BTC，ETH，USDT。输入您希望购买的金额。複製錢包地址進行轉賬，转账完成后, 不要忘记填写您的 "存款憑證"。请等待我们的财务团队确认您的存款. 您的资金将于10-30分鐘内显示在您的余额中。',
  index37: "联系我们",
  index38: "版权所有",
  index39: "注意",
  index40: "本网站的目的仅在于显示有关",
  index41: "应用程序上可用的产品和服务的信息应用程序上可用产品和服务的信息。它无意提供对任何此类产品和服务的访问。您可以在应用程序上访问此类产品和服务。",
  index42: "对于所有媒体和采访请求，请联系",
  index43: "寻找推广你的",
  index44: "对合作机会感兴趣",
  index45:"常见问题",
  index46:"给我们发电子邮件",



  about1:"我们是全球领先的数字货币资产交易平台，致力于为用户提供安全、专业、便捷的数字货币交易服务。我们切实从用户角度出发，凭借对区块链领域的深刻认知，为全球用户甄选优质币种，引领区块链技术潮流。",
  about2:"核心团队汇聚了资深技术工程师、全球区块链研究专家、国际化运营团队以及世界级风控专家等行业内顶尖人才，采用全球领先的加密技术，自主研发的集群式内存撮合系统，集合多币种，支持多语言，致力于为全球用户提供更安全、更稳定、更便捷的数字资产交易。",
  about3:"我们数字资产交易服务平台以数字资产交易服务为重点，提供专业的交易功能，智能交易和智能撮合，便捷交易，资金委托，账户轻松管理。同时与行业中大小型数字货币交易所进行联系合作，信息沟通交流，达成数字资产覆盖全世界的共同理念。",
  about4:"便捷流畅的用户体验，我们用心雕琢用户的使用习惯，本着体验至上的原则进行了全流程设计系统提供7-24不间断交易服务系统级的安全防护。深耕数字货币行业，积聚了大批数字货币行业的研发人才致力于为用户提供顶级的系统级安全保障。持续的引进各国数字货币为用户提供全球范围内的交易服务，丰富的数字货币币种收集货币市场中的优质币种，提供种类全面的数字货币",
  about5:"我们时刻倾听、关心和思进。我们希望可以融合加密货币和传统金融业的优势不断地创新。通过卓越的平台能力和专业的设计理念为我们的用户带来行业内最安全、高效、公平和透明的交易体验。",
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js